import { combineEpics, Epic } from "redux-observable";
import { agendaInstantEpic } from "../usecases/loadAgendaInstants/loadAgendaInstants.epic";

export const instantRootEpics: Epic =  combineEpics(agendaInstantEpic)
